const stateHost = process.env.NODE_ENV === 'development' ? 'http://localhost:8888' : 'https://ubports.kuailexs.com'

const configure = {
    state: {
        HOST: stateHost,
    },
    getters: {
        HOST: state => {
            return state.HOST
        },
    },
    mutations: {},
    actions: {}
}

export default configure
